import { render } from "./orderSummary.vue?vue&type=template&id=284ad044"
import script from "./orderSummary.vue?vue&type=script&lang=js"
export * from "./orderSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__